function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { Global } from '@emotion/core';
import { useTheme } from '@veneer/theme';
import resetStyles from './reset_styles';
import typographyStyles from './typography_styles';
import nativeFocus from '../utils/native_focus';
import { jsx as ___EmotionJSX } from "@emotion/core";
var html = {
  boxSizing: 'border-box',
  textRendering: 'optimizeLegibility',
  MozOsxFontSmoothing: 'grayscale',
  // Antialising.
  WebkitFontSmoothing: 'antialiased',
  // Antialiasing.
  WebkitTextSizeAdjust: '100%'
};
var styles = theme => _objectSpread(_objectSpread({}, resetStyles()), {}, {
  html,
  '*, *::before, *::after': {
    boxSizing: 'inherit'
  },
  body: {
    backgroundColor: theme.color.background.default,
    color: theme.color.foreground.default,
    margin: 0
  },
  'i, em, .italic': {
    fontStyle: 'italic'
  },
  'strong, b, .bold': {
    fontFamily: theme.typography.family0
  },
  'a, .link': _objectSpread({
    color: theme.color.primary.base.default,
    textDecoration: 'none',
    ':hover': {
      color: theme.color.primary.base.hover,
      textDecoration: 'underline'
    }
  }, nativeFocus(theme))
}, typographyStyles(theme));
var CssBaseline = () => {
  var theme = useTheme();
  return ___EmotionJSX(Global, {
    styles: styles(theme)
  });
};
CssBaseline.displayName = 'CssBaseline';
export default CssBaseline;